<!-- @Author: Yu_Bo 2023-09-06 11:33:31-->
<template>
    <div>
        <el-table :data="list" v-loading="loading" style="width: 100%" key="live_list" header-cell-class-name="table-header" cell-class-name="cell-class">
            <template slot="empty">
                <empty-data img='no_img_b.png' text='暂无数据'></empty-data>
            </template>
            <el-table-column prop="id" label="序号" width="100"></el-table-column>
            <el-table-column prop="name" label="模板名称"></el-table-column>
            <el-table-column label="模板缩略图">
                <template slot-scope="scope">
                    <div class="scope_img">
                        <el-image style="width:35px; height: 35px" :src="scope.row.cover_img" fit="scale-down" :preview-src-list="imgList"></el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="category.name" label="所属分类"></el-table-column>
            <el-table-column prop="ratio" label="比例">
                <template slot-scope="scope">
                    <span v-if="scope.row.ratio==1">16:9</span>
                    <span v-if="scope.row.ratio==2">9:16</span>
                </template>
            </el-table-column>
            <el-table-column label="是否免费">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_free==1">是</span>
                    <span v-if="scope.row.is_free==2">否</span>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="价格(钻石)"></el-table-column>
            <el-table-column label="上架状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_shelf" :active-value='1' :inactive-value='2' :key="scope.row.id" @change="changeSwitch($event,scope.row,scope.$index)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="member.nickname" label="创建人"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="170"></el-table-column>
            <el-table-column prop="update_time" label="更新时间" width="170"></el-table-column>
            <el-table-column class-name="last_class" label="操作" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="editModel(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="delModel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="page_box" v-if="total" style="padding-bottom: 20px;">
            <paging-page :total='total' align='right' @sizeChange='sizeChangeBtn' @currentChange='currentChangeBtn'></paging-page>
        </div>
        <!-- 删除提示 -->
        <point-out ref='dialogTip' dialogTitle="提示" type="market" @close='closeModel' dialogWidth='420px' :iconShow='true' iconColor='#FF7432' borderRadius='10px' :cancelShow='true' :affirmShow='true'>
            <div class="zc_dialog_tip_content">
                <div class="text">确定要删除该模板吗？删除后将无法恢复</div>
            </div>
        </point-out>
        <!-- 编辑 -->
        <add-edit ref="addedit" @affirm="getList"></add-edit>
    </div>
</template>

<script>
import PointOut from '@/components/point_out/point_out.vue'//提示
import EmptyData from '@/components/empty_data/empty_data.vue'//空数据
import PagingPage from '@/components/paging_page/paging_page.vue'//分页
import AddEdit from './add_edit'//分页

export default {
    components: { PointOut, EmptyData, PagingPage, AddEdit },
    props: {},
    data() {
        return {
            formData: {
                name: '',
                category_id: '',
                is_free:"",
                is_shelf:"",
            },
            // 
            list: [],
            imgList: [],
            loading: false,
            //
            page: 1,
            limit: 10,
            total: 0,
            // 
            delId: null,
        };
    },

    computed: {},

    watch: {},

    created() { },

    mounted() {
        this.getList()
    },

    methods: {
        // 列表数据
        getList() {
            var that = this
            that.loading = true
            var params = {
                ...that.formData,
                page: that.page,
                limit: that.limit,
            }
            that.$marketApi.liveTemplates(params).then(res => {
                that.loading = false
                if (res.code == 1000) {
                    that.list = res.result.data || []
                    that.total = res.result.total || 0
                    that.list.forEach(ele => {
                        that.imgList.push(ele.cover_img)
                    })
                } else {
                    that.$errMsg(res.message)
                }
            })
        },
        // 搜索
        search(info) {
            this.formData = info
            this.page = 1
            this.total = 0
            this.getList()
        },
        // 编辑
        editModel(item) {
            var obj = {
                id: item.id,
                name: item.name,
                category_id: item.category_id,
                is_free: item.is_free,
                price: item.price,
                is_shelf: item.is_shelf,
            }
            this.$refs.addedit.openDialog(obj)
        },
        // 删除
        delModel(val) {
            this.delId = val
            this.$refs.dialogTip.openDialogBtn()
        },
        // 确定删除
        closeModel() {
            var that = this
            if (that.delId != null) {
                that.$marketApi.delLive(that.delId).then(res => {
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.delId = null
                        if (that.list.length == 1) {
                            that.search(that.formData)
                        } else {
                            that.getList()
                        }
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            }
        },
        // 改变每页条数
        sizeChangeBtn(val) {
            this.limit = val
            this.page = 1
            this.getList()
        },
        // 改变页数
        currentChangeBtn(val) {
            this.page = val
            this.getList()
        },
        // 修改状态
        changeSwitch(val, info, index) {
            var that = this
            var params = {
                id: info.id,
                is_shelf: val
            }
            that.$marketApi.liveShelf(params).then(res => {
                if (res.code == 1000) {
                    that.list[index].is_shelf = val
                    that.$succMsg(res.message)
                } else {
                    that.list[index].is_shelf = val == 1 ? 2 : 1
                    that.$errMsg(res.message)
                }
            })
        },
    }
}
</script>
<style lang='scss' scoped>
.scope_img {
    padding-right: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>